import React from 'react';
import abtimg1 from "../images/abt-image1.jpeg"
import abtimg2 from "../images/abt-image2.jpeg"
const About = () => {
  return (
    <div className="page">
      <div className="container">
        <div className="page-hero compact-hero">
          <p className="hero-kicker">About Dynasty Agri Seeds</p>
          <h1>Built around research, disciplined production, and dependable quality control.</h1>
          <p>
            Dynasty Agri Seeds is focused on seed systems that help growers make practical decisions with more confidence.
          </p>
        </div>

        {/* Vokkal Seeds Section */}
        <section className="vokkal-section">
          <h2 className="vokkal-title">Dynasty Agri Seeds</h2>
          
          <div className="vokkal-content">
            <div className="vokkal-text">
              <p>
                Agriculture has been facing a lot of challenges with respect to quality, nutrition and increasing cost of production and changing weather pattern in the recent past. The immense population growth coupled with changing food habit has made Agricultural scientists to be more dynamic in evolving varieties for vegetable seeds which can yield better productivity at farmer's desired time with premium quality of produce with better shelf life in the markets.
              </p>
              <p>
                Through farmer has wide choice of crops and varieties but he is not getting suitable seeds to harvest the desired returns. Seed being a primary and most important input in crop production. He has been always looking for a dependable seed company which can offer him certified and guaranteed crop varieties at his desired time to get high market price.
              </p>
              <p>
                Dynasty Agri Seeds Pvt. Ltd. is one of the leading vegetable seeds companies located at Bangalore, India. prompted by a group of Agricultural professionals with vast experience in Seed Business management. One of our main objective is to take capable and quality vegetable seeds to the farming community to get maximum returns for their investment. The seeds are Research based and produced with an extra care to give a real value to the growers.
              </p>
            </div>
            
            <div className="vokkal-image">
              <img 
                src={abtimg1} 
                alt="Fresh tomatoes in hands" 
                loading="lazy"
              />
            </div>
          </div>

          {/* <div className="vokkal-quote">
            <h3>Quality is not an aim but is our attitude.</h3>
          </div> */}

          <div className="vokkal-content vokkal-content-reverse">
            <div className="vokkal-image">
              <img 
                src={abtimg2} 
                alt="Fresh tomatoes in hands" 
                loading="lazy"
              />
            </div>
            <div className="vokkal-text">
              <p>
                The company's research station is located near Bangalore with a team of dedicated breeders working intensively to add new hybrids and varieties required for the market to meet the challenges of disease & pest problems. His success is the main purpose of work.
              </p>
              <p>
                The seeds are produced by highly qualified and experienced production team which follows a Seed production process of high genetic purity and excellent germination to ensure high seedling vigor and good productivity. The company strongly believes in word of mouth promotional strategy of farmers' level for seed promotion and uses a multi channel strategy through extensive networks and conducting product demonstrations and field days in all the major vegetable growing areas to create grass root level awareness and seeds are made available at all important marketing distribution network by dedicated marketing team all over the country.
              </p>
              <p>
                The Company is assured both are one proprietor and maintains the quality is always our unchanging principle. Dynasty Agri Seeds Pvt. Ltd., being a local seed company is highly committed to get a real value and always work for "Quality to meet the challenging needs of a changing society.
              </p>
            </div>

            
          </div>
        </section>

        {/* Vision and Mission Section */}
        <section className="vokkal-mission-section">
          <div className="vokkal-cards">
            <div className="vokkal-card vision-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" width="40" height="40" fill="#2d6e2d">
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                </svg>
              </div>
              <h4>Our Vision</h4>
              <p>Timely supply of agro climatically suitable high quality vegetable seeds at affordable price to the farming community.</p>
            </div>

            <div className="vokkal-card mission-card">
              <div className="card-icon">
                <svg viewBox="0 0 24 24" width="40" height="40" fill="#2d6e2d">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
                </svg>
              </div>
              <h4>Our Mission</h4>
              <p>Eco-friendly segment wise breeding program with an international standards in operations to meet the growers need.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
